export const SOURCE_DIRECT = 'direct';
export const MEDIUM_ORGANIC = 'organic';
export const BANNER_CONTENT = 'mob-banner';



// WEBPACK FOOTER //
// ./app/constants/utm.js